import React from "react";

const AttentionMessage = (props) => {
  const content = props.content || null;

  return <>{content && <div className="attention-message">{content}</div>}</>;
};

export default AttentionMessage;
